import React, { useEffect } from "react";
import Breadcrumbs from "../../common/breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";

const PrivacyPolicy = () => {
    const htmlContent = `<p><strong>Effective Date:</strong> September 23, 2025</p>
<p>At <strong>Aagam Services</strong>,207, 2<sup>nd</sup> floor Manokamna Complex near sbi bank sector 11 Udaipur Rajsthan313001 operating as <strong>Namo Cars</strong>, we prioritize your privacy and are committed to safeguarding your personal information. This policy outlines how we collect, use, and protect your data when you interact with our services.</p>
<ol>
<li><strong> Information We Collect</strong></li>
</ol>
<p>We collect personal information to enhance your experience with our services. This may include:</p>
<ul>
<li><strong>Personal Details:</strong> Name, email address, phone number, and address.</li>
<li><strong>Identity Verification:</strong> Driving license and government-issued ID.</li>
<li><strong>Payment Information:</strong> Credit/debit card details for transaction processing.</li>
<li><strong>Vehicle Usage Data:</strong> GPS location, driving patterns, and vehicle diagnostics.</li>
<li><strong>Communication Records:</strong> Emails, support tickets, and feedback.</li>
</ul>
<ol>
<li><strong> How We Use Your Information</strong></li>
</ol>
<p>Your information helps us:</p>
<ul>
<li>Process bookings and payments.</li>
<li>Verify identity and eligibility.</li>
<li>Provide customer support and respond to inquiries.</li>
<li>Improve our services and website functionality.</li>
<li>Comply with legal obligations and resolve disputes.</li>
</ul>
<ol>
<li><strong> Data Security</strong></li>
</ol>
<p>We implement industry-standard security measures to protect your data. However, please note that no method of transmission over the internet is entirely secure. We strive to protect your personal information but cannot guarantee its absolute security.</p>
<ol>
<li><strong> Sharing Your Information</strong></li>
</ol>
<p>We do not sell, trade, or rent your personal information to third parties. We may share your data with trusted partners who assist in operating our services, provided they agree to keep this information confidential. Additionally, we may disclose information when legally required or to protect our rights and safety.</p>
<ol>
<li><strong> Cookies and Tracking Technologies</strong></li>
</ol>
<p>Our website may use cookies to enhance user experience. You can choose to disable cookies through your browser settings; however, some features of our site may not function properly without them.</p>
<ol>
<li><strong> Your Rights</strong></li>
</ol>
<p>You have the right to:</p>
<ul>
<li>Access and update your personal information.</li>
<li>Request the deletion of your data, subject to legal and contractual obligations.</li>
<li>Opt-out of marketing communications at any time.</li>
</ul>
<p>To exercise these rights, please contact us atnamocars16@gmail.com.</p>
<ol>
<li><strong> Third-Party Links</strong></li>
</ol>
<p>Our website may contain links to external sites. We are not responsible for the privacy practices or content of these sites. We encourage you to review the privacy policies of any third-party websites you visit.</p>
<ol>
<li><strong> Changes to This Policy</strong></li>
</ol>
<p>We may update this privacy policy periodically. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy regularly to stay informed about how we are protecting your information.</p>
<ol>
<li><strong> Contact Us</strong></li>
</ol>
<p>If you have any questions or concerns about this privacy policy or our data practices, please contact us:</p>
<p><strong>Email:</strong> namocars16@gmail.com<br/><strong>Phone:</strong> +91 7426999648<br/><strong>Address:Aagam Services</strong>,207,2<sup>nd</sup> floor Manokamna Complex near sbi bank sector 11 Udaipur Rajsthan 313001</p>`; // fixed closing tag

    useEffect(() => {
        AOS.init({ duration: 1200, once: true });
    }, []);

    return (
        <div className="main-wrapper">
            <Breadcrumbs title="Privacy Policy" subtitle="Pages" />

            <div className="privacy-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="terms-policy"
                                dangerouslySetInnerHTML={{ __html: htmlContent }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
